module.exports = __webpack_public_path__ + "849377dd9955004ffa915488230047f3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-BlackItalic.ttf
// module id = 1267
// module chunks = 0